import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: 'label[iosRequired]',
})
export class IosRequiredDirective implements OnChanges {
  @Input('iosRequired') mandatory: boolean;
  span = document.createElement('span');

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    this.span.innerText = this.mandatory ? '*' : '';
    this.el.nativeElement.appendChild(this.span);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const isMandatoryNow: boolean = changes.mandatory.currentValue;
    this.span.innerText = isMandatoryNow ? '*' : '';
  }
}
